import React, { useState } from 'react';

import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Input } from 'antd';

interface IProps {
  handleTokenApi: (tokenApi: string) => void;
  loading: boolean;
  tokenApi: string;
}

function ApiTokenForm({ handleTokenApi, tokenApi, loading }: IProps) {
  const [hasToken, setHasToken] = useState(false);

  return (
    <>
      <button
        className='text-primary! cursor-pointer! border-none! bg-transparent! p-0! text-base! font-medium!'
        onClick={() => setHasToken(!hasToken)}
      >
        {'Configurações de API de Conversões  '}
        {hasToken ? <UpOutlined style={{ fontSize: 'inherit' }} /> : <DownOutlined style={{ fontSize: 'inherit' }} />}
      </button>
      {hasToken && (
        <>
          <div className='mt-4' />
          <p className='text-text-secondary mb-0! text-[15px] font-normal'>Token API de Conversão</p>
          <Input
            disabled={loading}
            value={tokenApi}
            className='w-full'
            onChange={(e: any) => handleTokenApi(e.target.value)}
          />
          <div className='mt-2' />
          <p className='text-text-secondary mb-[9px]! text-[0.8rem]'>
            Dentro das configurações do seu Pixel do Facebok, vá na aba <b>Configurações</b> e em{' '}
            <b>API de Conversões</b>, dentro da sessão <b>Configurar Manualmente</b>, clique em{' '}
            <b>Gerar Token de Acesso</b>.
          </p>
        </>
      )}
    </>
  );
}

export default React.memo(ApiTokenForm);
